var _excluded = ["minDate", "maxDate", "excludeHolidays", "weekDays", "secondarySelectedDate", "showToday", "legendItems", "onSelect", "value", "backButton"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Group } from '../../../containers';
import { useBaseMenuContext } from '../../../containers/BaseMenu/hooks';
import { Icon } from '../../../foundations/Icon';
import { useBreakpoint } from '../../../theme';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { _BaseCalendar, Box } from '../../internal';
import { useIsSelectingDifferentDate } from './DatePicker.utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var _DatePicker = forwardRef((_ref, ref) => {
  var {
    minDate,
    maxDate,
    excludeHolidays,
    weekDays,
    secondarySelectedDate,
    showToday,
    legendItems,
    onSelect,
    value,
    backButton
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    isExtraSmallScreen: isMobile
  } = useBreakpoint();
  var styles = useMultiStyleConfig('DatePicker', {
    backButton,
    legendItems
  });
  var {
    setIsOpen
  } = useBaseMenuContext();

  var onClose = () => {
    setIsOpen(false);
  };

  var {
    isSelectingDifferentDate
  } = useIsSelectingDifferentDate();

  var onSelectDate = date => {
    if (isSelectingDifferentDate(value)(date)) {
      onSelect(date);
    }

    onClose();
  };

  var testId = 'dropdown-date-picker';
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    "data-component": "_DatePicker",
    "data-testid": testId,
    role: "menuitem",
    "aria-label": "date-picker",
    ref: ref,
    __css: styles['container']
  }, props), {}, {
    children: /*#__PURE__*/_jsxs(Group, {
      variant: "vertical",
      spacing: "none",
      hasDivider: true,
      children: [!isMobile && backButton && /*#__PURE__*/_jsx(Box, {
        "data-testid": "".concat(props['data-testid'] || testId, "-back-button"),
        as: "button",
        __css: styles['backButton'],
        onClick: backButton.onBack,
        children: /*#__PURE__*/_jsxs(Group, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(Icon, {
            type: "chevron-left",
            color: "inherit"
          }), backButton.label]
        })
      }), /*#__PURE__*/_jsx(Box, {
        __css: styles['calendarContainer'],
        children: /*#__PURE__*/_jsx(_BaseCalendar, {
          size: "small",
          onSelect: onSelectDate,
          minDate: minDate,
          maxDate: maxDate,
          excludeHolidays: excludeHolidays,
          weekDays: weekDays,
          secondarySelectedDate: secondarySelectedDate,
          showToday: showToday,
          selectedDate: value,
          legendItems: legendItems,
          isMobileDatePicker: isMobile
        })
      })]
    })
  }));
});
_DatePicker.displayName = '_DatePicker';
//# sourceMappingURL=_DatePicker.js.map